// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search Results Container */
.search-results-container {
  width: 100%;
  min-height: 100vh;
  padding: 2rem;
  background:transparent;
}

/* Content Wrapper - CSS Grid Layout */
.search-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 2rem;
  max-width: 100%;
}

/* Main Content Area */
.search-main-content {
  min-width: 0;
}

/* Search Header with Title and View Toggle */
.search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.search-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.05em;
  margin: 0;
}

/* View Toggle Buttons */
.view-toggle {
  display: flex;
  gap: 0.5rem;
  background: rgba(30, 30, 50, 0.6);
  padding: 0.25rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.view-toggle-btn {
  padding: 0.5rem;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-toggle-btn:hover {
  background: rgba(139, 92, 246, 0.1);
  color: rgba(255, 255, 255, 0.8);
}

.view-toggle-btn.active {
  background: rgba(139, 92, 246, 0.2);
  color: #8B5CF6;
}

/* Search Query Display */
.search-query-display {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(30, 30, 50, 0.4);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
}

.query-text {
  color: #8B5CF6;
  font-weight: 600;
}

/* Filter Indicator */
.filter-indicator {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(139, 92, 246, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(139, 92, 246, 0.3);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-text {
  color: #8B5CF6;
  font-weight: 600;
}

.clear-filter {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: rgba(255, 255, 255, 0.7);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.clear-filter:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

/* AI Summary Section */
.ai-summary-section {
  margin-bottom: 2rem;
  background: rgba(30, 30, 50, 0.6);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 16px;
  padding: 1.5rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.1);
}

.ai-summary-header {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.ai-summary-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  line-height: 1.5;
}

.ai-summary-content {
  position: relative;
  overflow: hidden;
  max-height: 120px;
  transition: max-height 0.3s ease;
}

.ai-summary-content.expanded {
  max-height: none;
}

.ai-summary-text {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  white-space: pre-wrap;
}

.ai-summary-toggle {
  margin-top: 1rem;
  background: rgba(139, 92, 246, 0.15);
  border: 1px solid rgba(139, 92, 246, 0.3);
  color: #8B5CF6;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ai-summary-toggle:hover {
  background: rgba(139, 92, 246, 0.25);
  border-color: rgba(139, 92, 246, 0.5);
  transform: translateY(-1px);
}

/* List View - Table */
.search-list-view {
  background: rgba(30, 30, 50, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  overflow: hidden;
}

.search-table {
  width: 100%;
  border-collapse: collapse;
}

.search-table thead {
  background: rgba(139, 92, 246, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.search-table th {
  padding: 1rem 1.5rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.search-table tbody tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.2s ease;
}

.search-table tbody tr:last-child {
  border-bottom: none;
}

.search-table-row {
  cursor: pointer;
}

.search-table-row:hover {
  background: rgba(139, 92, 246, 0.1);
}

.search-table td {
  padding: 1.25rem 1.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.search-table .name-cell {
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
  max-width: 400px;
}

/* Right Sidebar - Matching Lists */
.search-sidebar {
  width: 400px;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  height: fit-content;
}

.sidebar-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.05em;
  margin-bottom: 1.5rem;
  text-align: center;
}

.matching-lists {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Category Cards */
.category-card {
  background: rgba(30, 30, 50, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: row;
  justify-content: space-between
  ;
}

.category-card:hover {
  background: rgba(40, 40, 60, 0.7);
  border-color: rgba(139, 92, 246, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15);
}

.category-card.selected {
  background: rgba(139, 92, 246, 0.15);
  border-color: rgba(139, 92, 246, 0.6);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);
}

.category-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 0.25rem;
}

.category-count {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
  background-color: rgba(139, 92, 246, 0.15);
  padding:0.5em 0.5rem;
  border-radius: 6px;
}

.category-card.selected .category-count {
  color: #8B5CF6;
  font-weight: 600;
}

/* Loading State */
.search-loading {
  text-align: center;
  padding: 4rem 2rem;
  background: rgba(30, 30, 50, 0.4);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.search-loading p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  margin-top: 1rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border: 4px solid rgba(139, 92, 246, 0.2);
  border-top: 4px solid #8B5CF6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error State */
.search-error {
  text-align: center;
  padding: 3rem 2rem;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.error-message {
  color: #ef4444;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.retry-button {
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.4);
  color: #8B5CF6;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.retry-button:hover {
  background: rgba(139, 92, 246, 0.3);
  border-color: rgba(139, 92, 246, 0.6);
  transform: translateY(-2px);
}

/* No Results Message */
.no-results {
  text-align: center;
  padding: 3rem 2rem;
  background: rgba(30, 30, 50, 0.4);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.no-results p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 1rem;
  margin: 0;
}

/* Search Materials Grid - Base Layout */
.search-materials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 1.5rem;
}

/* Grid Column Adjustments Based on Sidebar State */
/* When sidebar is pinned (expanded) - 2 columns for cards */
.content_pinned .search-materials-grid {
  grid-template-columns: repeat(2, 1fr) !important;
}

/* When sidebar is unpinned (minimized) - 3 columns for cards */
.content_unpinned .search-materials-grid {
  grid-template-columns: repeat(3, 1fr) !important;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .search-content-wrapper {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .search-sidebar {
    width: 100%;
  }

  .matching-lists {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .category-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 0.5rem);
    min-width: 150px;
  }

  /* Reset grid columns for tablet */
  .content_pinned .search-materials-grid,
  .content_unpinned .search-materials-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 768px) {
  .search-results-container {
    padding: 1rem;
  }

  .search-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .view-toggle {
    width: 100%;
    justify-content: center;
  }

  /* AI Summary responsive */
  .ai-summary-section {
    padding: 1rem;
  }

  .ai-summary-title {
    font-size: 1rem;
  }

  .ai-summary-text {
    font-size: 0.875rem;
    line-height: 1.6;
  }

  .search-table th,
  .search-table td {
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
  }

  .search-table .name-cell {
    max-width: 200px;
  }

  .category-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.375rem);
  }

  /* Single column for mobile */
  .content_pinned .search-materials-grid,
  .content_unpinned .search-materials-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (max-width: 480px) {
  .search-table {
    font-size: 0.8rem;
  }

  .search-table th,
  .search-table td {
    padding: 0.5rem 0.75rem;
  }

  /* Stack table for very small screens */
  .search-table thead {
    display: none;
  }

  .search-table tbody tr {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    margin-bottom: 0.5rem;
    background: rgba(30, 30, 50, 0.6);
    border-radius: 8px;
  }

  .search-table td {
    padding: 0.25rem 0;
    border: none;
  }

  .search-table td:before {
    content: attr(data-label);
    font-weight: 600;
    display: inline-block;
    width: 120px;
    color: rgba(255, 255, 255, 0.6);
  }

  .category-card {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/search.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB;EACA;AACF;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD,4DAA4D;AAC5D;EACE,gDAAgD;AAClD;;AAEA,+DAA+D;AAC/D;EACE,gDAAgD;AAClD;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAgC;IAAhC,cAAgC;IAAhC,kCAAgC;IAChC,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA,0BAA0B;EAC1B;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;EAChC;;EAEA,6BAA6B;EAC7B;;IAEE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA,uCAAuC;EACvC;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,+BAA+B;EACjC;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Search Results Container */\n.search-results-container {\n  width: 100%;\n  min-height: 100vh;\n  padding: 2rem;\n  background:transparent;\n}\n\n/* Content Wrapper - CSS Grid Layout */\n.search-content-wrapper {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: 2rem;\n  max-width: 100%;\n}\n\n/* Main Content Area */\n.search-main-content {\n  min-width: 0;\n}\n\n/* Search Header with Title and View Toggle */\n.search-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.search-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.05em;\n  margin: 0;\n}\n\n/* View Toggle Buttons */\n.view-toggle {\n  display: flex;\n  gap: 0.5rem;\n  background: rgba(30, 30, 50, 0.6);\n  padding: 0.25rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.view-toggle-btn {\n  padding: 0.5rem;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.view-toggle-btn:hover {\n  background: rgba(139, 92, 246, 0.1);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.view-toggle-btn.active {\n  background: rgba(139, 92, 246, 0.2);\n  color: #8B5CF6;\n}\n\n/* Search Query Display */\n.search-query-display {\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: rgba(30, 30, 50, 0.4);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9rem;\n}\n\n.query-text {\n  color: #8B5CF6;\n  font-weight: 600;\n}\n\n/* Filter Indicator */\n.filter-indicator {\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: rgba(139, 92, 246, 0.1);\n  border-radius: 8px;\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filter-text {\n  color: #8B5CF6;\n  font-weight: 600;\n}\n\n.clear-filter {\n  margin-left: auto;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.clear-filter:hover {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n/* AI Summary Section */\n.ai-summary-section {\n  margin-bottom: 2rem;\n  background: rgba(30, 30, 50, 0.6);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 16px;\n  padding: 1.5rem;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.1);\n}\n\n.ai-summary-header {\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.ai-summary-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.ai-summary-content {\n  position: relative;\n  overflow: hidden;\n  max-height: 120px;\n  transition: max-height 0.3s ease;\n}\n\n.ai-summary-content.expanded {\n  max-height: none;\n}\n\n.ai-summary-text {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.95rem;\n  line-height: 1.8;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.ai-summary-toggle {\n  margin-top: 1rem;\n  background: rgba(139, 92, 246, 0.15);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  color: #8B5CF6;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ai-summary-toggle:hover {\n  background: rgba(139, 92, 246, 0.25);\n  border-color: rgba(139, 92, 246, 0.5);\n  transform: translateY(-1px);\n}\n\n/* List View - Table */\n.search-list-view {\n  background: rgba(30, 30, 50, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  overflow: hidden;\n}\n\n.search-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.search-table thead {\n  background: rgba(139, 92, 246, 0.1);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.search-table th {\n  padding: 1rem 1.5rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.search-table tbody tr {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  transition: all 0.2s ease;\n}\n\n.search-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.search-table-row {\n  cursor: pointer;\n}\n\n.search-table-row:hover {\n  background: rgba(139, 92, 246, 0.1);\n}\n\n.search-table td {\n  padding: 1.25rem 1.5rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n}\n\n.search-table .name-cell {\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.95);\n  max-width: 400px;\n}\n\n/* Right Sidebar - Matching Lists */\n.search-sidebar {\n  width: 400px;\n  flex-shrink: 0;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  height: fit-content;\n}\n\n.sidebar-title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.05em;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.matching-lists {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n/* Category Cards */\n.category-card {\n  background: rgba(30, 30, 50, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(10px);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between\n  ;\n}\n\n.category-card:hover {\n  background: rgba(40, 40, 60, 0.7);\n  border-color: rgba(139, 92, 246, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15);\n}\n\n.category-card.selected {\n  background: rgba(139, 92, 246, 0.15);\n  border-color: rgba(139, 92, 246, 0.6);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);\n}\n\n.category-name {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.95);\n  margin-bottom: 0.25rem;\n}\n\n.category-count {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.5);\n  background-color: rgba(139, 92, 246, 0.15);\n  padding:0.5em 0.5rem;\n  border-radius: 6px;\n}\n\n.category-card.selected .category-count {\n  color: #8B5CF6;\n  font-weight: 600;\n}\n\n/* Loading State */\n.search-loading {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: rgba(30, 30, 50, 0.4);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.search-loading p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n  margin-top: 1rem;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  margin: 0 auto;\n  border: 4px solid rgba(139, 92, 246, 0.2);\n  border-top: 4px solid #8B5CF6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error State */\n.search-error {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: rgba(239, 68, 68, 0.1);\n  border-radius: 12px;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.error-message {\n  color: #ef4444;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n}\n\n.retry-button {\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.4);\n  color: #8B5CF6;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.retry-button:hover {\n  background: rgba(139, 92, 246, 0.3);\n  border-color: rgba(139, 92, 246, 0.6);\n  transform: translateY(-2px);\n}\n\n/* No Results Message */\n.no-results {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: rgba(30, 30, 50, 0.4);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.no-results p {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* Search Materials Grid - Base Layout */\n.search-materials-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n/* Grid Column Adjustments Based on Sidebar State */\n/* When sidebar is pinned (expanded) - 2 columns for cards */\n.content_pinned .search-materials-grid {\n  grid-template-columns: repeat(2, 1fr) !important;\n}\n\n/* When sidebar is unpinned (minimized) - 3 columns for cards */\n.content_unpinned .search-materials-grid {\n  grid-template-columns: repeat(3, 1fr) !important;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .search-content-wrapper {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n  }\n\n  .search-sidebar {\n    width: 100%;\n  }\n\n  .matching-lists {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .category-card {\n    flex: 1 1 calc(33.333% - 0.5rem);\n    min-width: 150px;\n  }\n\n  /* Reset grid columns for tablet */\n  .content_pinned .search-materials-grid,\n  .content_unpinned .search-materials-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .search-results-container {\n    padding: 1rem;\n  }\n\n  .search-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .view-toggle {\n    width: 100%;\n    justify-content: center;\n  }\n\n  /* AI Summary responsive */\n  .ai-summary-section {\n    padding: 1rem;\n  }\n\n  .ai-summary-title {\n    font-size: 1rem;\n  }\n\n  .ai-summary-text {\n    font-size: 0.875rem;\n    line-height: 1.6;\n  }\n\n  .search-table th,\n  .search-table td {\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .search-table .name-cell {\n    max-width: 200px;\n  }\n\n  .category-card {\n    flex: 1 1 calc(50% - 0.375rem);\n  }\n\n  /* Single column for mobile */\n  .content_pinned .search-materials-grid,\n  .content_unpinned .search-materials-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .search-table {\n    font-size: 0.8rem;\n  }\n\n  .search-table th,\n  .search-table td {\n    padding: 0.5rem 0.75rem;\n  }\n\n  /* Stack table for very small screens */\n  .search-table thead {\n    display: none;\n  }\n\n  .search-table tbody tr {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    margin-bottom: 0.5rem;\n    background: rgba(30, 30, 50, 0.6);\n    border-radius: 8px;\n  }\n\n  .search-table td {\n    padding: 0.25rem 0;\n    border: none;\n  }\n\n  .search-table td:before {\n    content: attr(data-label);\n    font-weight: 600;\n    display: inline-block;\n    width: 120px;\n    color: rgba(255, 255, 255, 0.6);\n  }\n\n  .category-card {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
